<template>
    <layout-general-container spaceToolbar>
        <banner />
        <statistic />
        <benefit />
        <div class="flex flex-col w-full items-center justify-center px-3 md:px-10 pt-20 pb-8 gap-28">
            <course-overview />
            <program-overview />
            <testimonial />
            <news-overview />
        </div>

        <powered-by />
    </layout-general-container>
</template>